import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.STORAGE_SET_STORAGE_LIST]: (state, payload) => {
    state.storageList = payload.storageList
  }
}

export default Mutations
